import {WlModal} from "./modal.component";
import {defineWebComponent} from "../webcomponents-utils";
export * from './modal.component';

defineWebComponent("wl-modal", WlModal)